import {ReactNode} from "react";

// Части текста, заключённые в ** как в markdown, выделяем жирным,
// а заключённые в __ — переносим только целиком (nobr)
const BOLD_PATTERN = /\*\*(.+?)\*\*/g;
const NOBR_PATTERN = /__(.+?)__/g;
// Новый объект на каждый вызов: разметка разбирается рекурсивно,
// а общий regex с флагом g делил бы lastIndex между уровнями вложенности
const createMarkupPattern = () => /\*\*(.+?)\*\*|__(.+?)__/g;

/**
 * Преобразует **текст** в <strong>текст</strong>,
 * а __текст__ — в <span className="text-nowrap">текст</span>.
 * Разметка может быть вложенной: **жирный __неразрывный__**.
 * Если разметки нет, возвращает исходную строку без изменений.
 */
export function formatBoldText(text?: string | null): ReactNode {
    if (!text || (!text.includes('**') && !text.includes('__'))) {
        return text;
    }

    const parts: ReactNode[] = [];
    let lastIndex = 0;
    let match: RegExpExecArray | null;

    const markupPattern = createMarkupPattern();
    while ((match = markupPattern.exec(text)) !== null) {
        parts.push(text.substring(lastIndex, match.index));

        if (match[1] !== undefined) {
            parts.push(<strong key={match.index}>{formatBoldText(match[1])}</strong>);
        } else {
            parts.push(<span className="text-nowrap" key={match.index}>{formatBoldText(match[2])}</span>);
        }

        lastIndex = match.index + match[0].length;
    }

    parts.push(text.substring(lastIndex));

    return <>{parts}</>;
}

/**
 * Убирает ** и __ из текста. Нужно там, где markdown отрисовать нельзя:
 * title страницы, meta-теги, alt, аналитика.
 */
export function stripBoldMarkers(text?: string | null): string {
    if (!text) {
        return '';
    }

    return text.replace(BOLD_PATTERN, '$1').replace(NOBR_PATTERN, '$1');
}
